<template>
    <v-container fluid grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12>
                <v-container fluid grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs4>
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light" v-show="viewType === 'MSSL'">Stock on hand at JMP</h1>
                                <h1 class="title font-weight-light" v-show="viewType === 'JMP'">Raw Material Stock</h1>
                            </v-layout>
                        </v-flex>
                        <v-flex xs1>
                            <v-btn color="accent" dark small right fab :loading="isBusy" class="el-m-t-10" @click="loadData" v-show="viewType === 'MSSL'">
                                <v-icon>autorenew</v-icon>
                            </v-btn>
                            <v-btn color="accent" dark small right fab :loading="isBusyRaw" class="el-m-t-10" @click="loadRawData" v-show="viewType === 'JMP'">
                                <v-icon>autorenew</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs3>
                            <v-radio-group row v-model="viewType">
                                <v-radio label="MSSL" value="MSSL"></v-radio>
                                <v-radio label="JMP" value="JMP"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex xs4 v-show="viewType === 'MSSL'">
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter the list" :hint="`(${searchAt.text}) MSSL Ref, Description or JMP Ref`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 v-show="viewType === 'MSSL'">
                            <v-card>
                                <v-data-table :headers="headers" :items="tableData" :loading="isBusy" hide-actions disable-initial-sort>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <td>
                                                <div>{{ props.item.No}}</div>
                                                <div>{{ ' '}}</div>
                                            </td>    
                                            <!-- <td>
                                                <div>{{ props.item.Flag}}</div>
                                            </td>-->
                                            <td>
                                                <div>{{ props.item.Mssl }}</div>
                                                <div>{{ 'PONo : ' }}{{ props.item.PON }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.Description }}</div>
                                                <div>{{ '@ R' }}{{ props.item.Price}}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.JMPRef }}</div>
                                                <div>{{ }}</div>
                                            </td>
                                            <td class="text-xs-right">
                                                <div>{{ $format.int(props.item.FCCurr) }}</div>
                                                <div>{{ }}</div>
                                            </td>                                                                                                                                  
                                            <td class="text-xs-right">
                                                <div>{{ $format.int(props.item.StkQty) }}</div>
                                                <div>{{ }}</div>
                                            </td>
                                            <td class="text-xs-right">
                                                <div>{{ $format.int(props.item.OnOrd) }}</div>
                                                <div>{{ }}</div>
                                            </td>
                                            <td class="text-xs-right">
                                                <div>{{  $format.int(props.item.Qty) }}</div>                                                
                                            </td>                                            
                                            <td class="text-xs-right">
                                                <div>{{ $format.int(props.item.FCNext) }}</div>
                                                <div>{{ }}</div>
                                            </td>                                                                        
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>Waiting for data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="pager.currentPage" :length="pager.pages" :total-visible="5" @next="loadData" @previous="loadData" @input="loadData"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="pager.pageSize" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;" @change="loadData"></v-select>
                                    </div>
                                </div>
                            </v-card>
                        </v-flex>
                        <!-- ----------------------------------------------------------------------------------------------------------------- -->

                        <!-- ----------------------------------------------------------------------------------------------------------------- -->
                        <!-- <v-flex xs5>
                            <v-layout align-center justify-end row fill-height>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on" @click="toggleSearchAt">
                                            <v-icon>{{ searchAt.icon }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Match search text at this position</span>
                                </v-tooltip>
                                <v-text-field ref="search" v-model="searchText" placeholder="Type here to filter the list" :hint="`(${searchAt.text}) MSSL Ref, Description or JMP Ref`" persistent-hint prepend-icon="search" clearable @keyup.native="searchChange" @click:clear="searchChange"></v-text-field>
                            </v-layout>
                        </v-flex> -->
                        <!-- ----------------------------------------------------------------------------------------------------------------- -->
                        <v-flex xs12 v-show="viewType === 'JMP'">
                            <v-card>
                                <v-data-table :headers="JMPheaders" :items="jmpTableData" :loading="isBusyRaw" hide-actions disable-initial-sort>
                                    <template slot="items" slot-scope="props">
                                        <tr>
                                            <!-- <td>
                                                <div>{{ props.item.Flag}}</div>
                                            </td>                                                                                      -->
                                            <td>
                                                <div>{{ props.item.CN_REF }}</div>
                                            </td>
                                            <td>
                                                <div>{{ props.item.CN_DESC }}</div>
                                            </td>
                                            <td class="text-xs-right"   >
                                                <div>{{ (props.item.CN_FACT) }}</div>
                                            </td>                                            
                                            <td class="text-xs-right">
                                                <div>{{ $format.int(props.item.CN_INSTOCK)  }}</div>
                                            </td>
                                            <td class="text-xs-right">
                                                <div>{{ $format.int(props.item.CN_ONORDER) }}</div>
                                            </td>
                                            <td class="text-xs-right text-no-wrap">
                                                <div>{{ $format.int(props.item.date) }}</div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template slot="no-data">
                                        <v-subheader>Waiting for data.</v-subheader>
                                    </template>
                                </v-data-table>
                                <v-divider></v-divider>
                                <!-- <div class="el-clearfix">
                                    <div class="pt-2 pb-1 el-float-left">
                                        <v-pagination v-model="pager2.currentPage" :length="pager2.pages" :total-visible="5" @next="loadRawData" @previous="loadRawData" @input="loadRawData"></v-pagination>
                                    </div>
                                    <div class="pb-1 pl-2 el-float-right">
                                        <v-select v-model="pager2.pageSize" :items="pageSizes" label="Page Size" dense hide-details style="max-width:80px;" @change="loadRawData"></v-select>
                                    </div>
                                </div> -->
                            </v-card>
                        </v-flex>
                        <!-- ----------------------------------------------------------------------------------------------------------------- -->                        
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="isDialogBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Constants from '../../util/Constants';

export default {
    name: 'MSSL',
    props: {},
    data() {
        return {
            user: { has: () => 0 },
            ViewCompany: {},
            searchText: '',
            viewType: 'MSSL',
            btnCol: 'green',
            viewToggle: true,
            searchOptions: Constants.SEARCH_OPTIONS,
            searchAt: {},
            searchAtOptions: Constants.SEARCH_AT_OPTIONS,
            selected: null,
            msslParts: [],
            headers: [
                { text: 'JMP No', value: 'No', align: 'left', width: '30px', sortable: false },
                // { text: 'Flag', value: 'Flag', align: 'left', width: '30px' },
                { text: 'MSSL Reference', value: 'Mssl', align: 'left', width: '180px' },
                { text: 'Description', value: 'Description', align: 'left' },
                { text: 'JMP Ref', value: 'JMPRef', align: 'left', width: '180px' },
                { text: 'Forcast Curr', value: 'FCCurr', align: 'right', width: '100px', sortable: false },
                { text: 'Stock On Hand', value: 'StkQty', align: 'right', width: '100px', sortable: false },
                { text: 'Stock On Order', value: 'OnOrd', align: 'right', width: '100px', sortable: false },
                { text: 'Current Sales', value: 'Qty', align: 'right', width: '100px', sortable: false },
                { text: 'Forcast Next', value: 'FCNext', align: 'right', width: '100px', sortable: false }
            ],
            pager: {
                pageSize: 15,
                currentPage: 1,
                pages: 1,
                totalRecords: 0
            },
            JMPheaders: [
                // { text: 'Flag', value: 'Flag', align: 'left', width: '30px' },
                { text: 'Stock Reference', value: 'CN_REF', align: 'left', width: '180px' },
                { text: 'Description', value: 'CN_DESC', align: 'left' },
                { text: 'Unit', value: 'CN_FACT', align: 'right', width: '80px' },
                { text: 'Instock', value: 'CN_INSTOCK', align: 'right', width: '100px' },
                // { text: 'Allocated', value: 'CN_ALLOC', align: 'right', width: '100px' },
                { text: 'On Order', value: 'CN_ONORDER', align: 'right', width: '100px' },
                { text: 'E.T.A.', value: 'date', align: 'right', width: '100px' }
            ],
            pager2: {
                pageSize: 10,
                currentPage: 1,
                pages: 1,
                totalRecords: 0
            },
            sortField: { No: 1 },
            pageSizes: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
            isBusy: false,
            isBusyRaw: false,
            isDialogBusy: false,
            tableData: [],
            jmpTableData: []
        };
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.searchText = '';
            this.loadData();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.pager.pageSize = this.$ls.get('PageSize_Quotes', 15);
        this.searchAt = this.searchAtOptions[2];
        this.loadData();
        this.loadRawData();
        this.postMsslCurSales();
        setTimeout(() => this.$refs.search.focus(), 250);
    },
    methods: {
        async loadData() {
            // this.getMsslStk();
            try {
                this.isBusy = true;
                this.searchText = this.searchText || '';
                const response = await this.$http.post('/jmpcontroller/postMssl', { search: this.searchText.trim(), searchAt: this.searchAt.value, C_Id: this.ViewCompany._id, _page: { per: this.pager.pageSize, page: this.pager.currentPage }, _sort: this.sortField });
                this.pager.totalRecords = response.data.p.t;
                this.pager.pages = response.data.p.pt;
                const tdata = response.data.d;

                const respqtr = await this.$http.post('/jmpcontroller/postMsslCurSales');

                respqtr.data.d.forEach(el => {
                    const Ref = el._id.substr(0, 16); // SA_PRODUCT = _Id

                    const fnd = tdata.find(o => o.JMPRef === Ref);
                    if (fnd) {
                        fnd.Qty = el.Total;
                    }
                });
                const resp = await this.$http.post('/jmpcontroller/postMsslPON');

                resp.data[0].P.forEach(e => {
                    const fnd = e.Desc.substr(0, 16);
                    const fpn = e.Comm;
                    const fpr = e.Price;
                    // const JRef = e.Item.substr(0, 16);
                    // const Mon = e.mon;
                    const pon = tdata.find(o => o.Mssl === fnd);
                    if (pon) {
                        pon.PON = fpn;
                        pon.Price = fpr;
                    }
                });
                this.tableData = tdata;
                // this.postMsslCurSales();
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        async postMsslCurSales() {
            try {
                // const response = await this.$http.post('/jmpcontroller/postMsslCurSales', { Ref: Ref });
                const response = await this.$http.post('/jmpcontroller/postMsslCurSales');
                // console.log(response.data);
                response.data.d.forEach(el => {
                    // response.data.filter(mon===3);
                    // const fnd = el.Desc.substr(0,16);
                    const Mon = el.mon;
                    const Ref = (el.SA_PRODUCT || '').substr(0, 16);
                    const Qty = el.SA_QTY;
                    if (Mon) {
                        // console.log("Ref",Ref, Mon, Qty);
                        const fnd = this.tableData.find(o => o.JMPRef === Ref);
                        if (fnd) {
                            fnd.Qty = Qty;
                        }
                        // console.log(this.tableData);
                    }
                    // console.log(this.tableData);
                });
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the Sales data.' });
            }
            finally {
                this.isBusy = false;
            }
        },
        async loadRawData() {
            try {
                this.isBusyRaw = true;
                // 001252910000000T
                // const CRef = '001255911000091T';
                const response = await this.$http.post('/jmpcontroller/postRawMatInfo');
                // console.log(response.data[0].CN_REF);
                // debugger;
                // const respdte = await this.$http.post('/jmpcontroller/postMsslDueDate', { myref: CRef });
                // debugger;
                // console.log("My Data", CRef, respdte.d.data);
                response.data.forEach(async e => {
                    // e.CN_COST /= 10000;
                    // mydat = e.data[0].CN_REF
                    // console.log(e.CN_REF);
                    const CRef = e.CN_REF;
                    // console.log('Here:',CRef);
                    const respdte = await this.$http.post('/jmpcontroller/postMsslDueDate', { myref: CRef });

                    if (respdte.data.d[0]) {
                         // console.log("Data");
                        const due = respdte.data.d[0].Due;
                        e.date = due;
                    }
                    else {
                         // console.log("No Data");
                        e.date = 'No Orders';
                    }

                    e.fact = e.CN_FACT.substr(2, 1);
                    e.CN_FACT = e.CN_FACT.substr(0, 2);
                    e.CN_INSTOCK /= Math.pow(10, e.fact);
                    e.CN_ALLOC /= Math.pow(10, e.fact);
                    e.CN_ONORDER /= Math.pow(10, e.fact);
                });
                this.jmpTableData = response.data;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
            finally {
                this.isBusyRaw = false;
            }
        },
        toggleSearchAt() {
            let pos = this.searchAtOptions.indexOf(this.searchAt);
            pos += 1;
            if (pos === this.searchAtOptions.length) pos = 0;
            this.searchAt = this.searchAtOptions[pos];
            if (this.searchText.trim().length) this.loadData();
            this.$refs.search.focus();
        },
        searchChange() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.pager.currentPage = 1;
                this.loadData();
            }, 600);
        }
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Supplier/MSSL.vue